module.exports = ['$scope', '$routeParams', 'railsResource',
($scope, $routeParams, $resource) ->
  Holding = $resource '/holdings/:id', { id: '@id' }
  HoldingPrices = $resource '/holdings/:id/prices', { id: '@id' }
  HoldingDividends = $resource '/holdings/:id/dividends', { id: '@id' }

  @listPath = -> 'holdings'

  @holding = Holding.get { id: $routeParams.id }

  HoldingPrices.query id: $routeParams.id, (data) => @priceHistory = data

  @editPath = => "holdings/#{@holding.id}/edit"

  @
]
